'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

var _NavigatorEvent = require('../NavigatorEvent');

var NavigatorEvent = _interopRequireWildcard(_NavigatorEvent);

var _NavigationResponderBehaviors = require('../NavigationResponderBehaviors');

var _NavigationResponderBehaviors2 = _interopRequireDefault(_NavigationResponderBehaviors);

var _TransitionStatus = require('../transition/TransitionStatus');

var TransitionStatus = _interopRequireWildcard(_TransitionStatus);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//  weak
/* eslint "no-use-before-define": 1 */
var _navigator = null;
var _template = '\n<div class="debugConsole">Path: <input type="text" class="path" />\n<div class="pathRenderer"></div><div class="responders">\n<div class="names"></div><div class="status"></div></div></div>\n';
var _visible = true;
var _inputRegex = new RegExp('[-_/A-Za-z0-9]');
var _$el = null;
var _$pathInput = null;
var _$pathRenderer = null;
var _$responders = null;
var _$responderNames = null;
var _$responderStatus = null;
var _respondersByID = null;
var _statusByResponderID = null;

// Input keydown validation and requesting the entered path
var _onKeyPress = function _onKeyPress(e) {
    switch (e.which) {
        case 13:
            // Return
            e.preventDefault(); // Prevent char from writing in textfield
            _navigator.request(_$pathInput.val());
            return;
        case 8: // Backspace
        case 0:
            // Others such as arrows
            return; // This can just be execute
        default:
            break;
    }

    var char = String.fromCharCode(e.which);
    if (!_inputRegex.test(char)) {
        e.preventDefault(); // Prevent char from writing in textfield
    }

    _autoSizeInput();
};

// Toggle showing debug console
var _onWindowKeyPress = function _onWindowKeyPress(e) {
    switch (String.fromCharCode(e.which)) {
        case '~':
        case '$':
        case '`':
            _visible = !_visible;
            _$el.css({ display: _visible ? '' : 'none' });
            break;
        default:
            break;
    }
};

var _onResponderClick = function _onResponderClick(e) {
    var responderID = (0, _jquery2.default)(e.target).data('responder-id');

    console.log('Responder', _respondersByID[responderID]);
};

var _autoSizeInput = function _autoSizeInput() {
    _$pathRenderer.text(_$pathInput.val());
    _$pathInput.css({ width: _$pathRenderer.width() });
};

var _handleStatusUpdated = function _handleStatusUpdated(e, data) {
    _respondersByID = data.respondersByID;
    _statusByResponderID = data.statusByResponderID;
    _updateDisplay();
};

var _updateDisplay = function _updateDisplay() {
    var currentState = _navigator.getCurrentState();
    var responderID = void 0;
    var responder = void 0;
    var status = void 0;
    var color = void 0;
    var responderNamesHTMLString = '';
    var responderStatusHTMLString = '';
    if (!currentState) {
        return;
    }

    _$pathInput.val(currentState.getPath());
    _autoSizeInput();

    for (responderID in _respondersByID) {
        responder = _respondersByID[responderID];
        status = _statusByResponderID[responderID];

        if (_NavigationResponderBehaviors2.default.implementsBehaviorInterface(responder, 'IHasStateTransition') || _NavigationResponderBehaviors2.default.implementsBehaviorInterface(responder, 'IHasStateInitialization')) {
            responderNamesHTMLString += '<span data-responder-id="' + responderID + '">' + _getResponderString(responder) + '</span><br />';
            color = _getColorByStatus(status);
            responderStatusHTMLString += '<span style=" color:' + color + '; font-weight:bold;" data-responder-id="' + responderID + '">\n                ' + TransitionStatus.toString(status) + '</span><br />';
        }
    }

    _$responderNames.html(responderNamesHTMLString);
    _$responderStatus.html(responderStatusHTMLString);
};

var _getResponderString = function _getResponderString(responder) {
    var responderString = responder.toString();

    if (responderString === '[object Object]' && responder.$el) {
        var tagName = responder.$el.prop('tagName').toLowerCase();
        var classes = responder.$el.attr('class').split(' ').join('.');

        responderString = tagName + '.' + classes;
    }

    return responderString;
};

var _getColorByStatus = function _getColorByStatus(status) {
    var color = '';
    switch (status) {
        case TransitionStatus.UNINITIALIZED:
            color = '#AAAAAA';
            break;
        case TransitionStatus.INITIALIZED:
            color = '#FFFFFF';
            break;
        case TransitionStatus.HIDDEN:
            color = '#FF0000';
            break;
        case TransitionStatus.APPEARING:
        case TransitionStatus.DISAPPEARING:
            color = '#FFFF00';
            break;
        case TransitionStatus.SHOWN:
            color = '#00FF00';
            break;
        default:
            break;
    }

    return color;
};

var DebugConsole = function DebugConsole(navigator) {
    _navigator = navigator;

    _$el = (0, _jquery2.default)(_template);
    _$pathInput = _$el.find('.path');
    _$pathRenderer = _$el.find('.pathRenderer');
    _$responders = _$el.find('.responders');
    _$responderNames = _$responders.find('.names');
    _$responderStatus = _$responders.find('.status');

    // STYLING
    _$el.css({
        backgroundColor: '#000000',
        color: '#AAAAAA',
        fontFamily: 'Arial',
        fontSize: 12,
        padding: 5
    });

    _$pathInput.css({
        color: '#00FF00',
        backgroundColor: 'transparent',
        fontFamily: 'Arial',
        fontSize: 12,
        minWidth: 200,
        border: 0
    });

    _$pathRenderer.attr('style', _$pathInput.attr('style'));
    _$pathRenderer.css({
        position: 'absolute',
        height: 0,
        overflowY: 'hidden'
    });

    _$responderNames.css({
        display: 'inline-block',
        color: '#FF9900',
        marginRight: 15
    });

    _$responderStatus.css({
        display: 'inline-block'
    });

    _$pathInput.on('keypress', _onKeyPress);
    (0, _jquery2.default)(window).on('keypress', _onWindowKeyPress);

    _$responderNames.on('click', _onResponderClick);
    _$responderStatus.on('click', _onResponderClick);

    _navigator.on(NavigatorEvent.STATE_CHANGED, _handleStatusUpdated);
    _navigator.on(NavigatorEvent.TRANSITION_STATUS_UPDATED, _handleStatusUpdated);
};

// PUBLIC API
DebugConsole.prototype = {
    get$El: function get$El() {
        return _$el;
    }
};

exports.default = DebugConsole;
//# sourceMappingURL=DebugConsole.js.map